import { themedUseStyletron } from '../../../theme/customTheme'
import { ValueDisplayWithLabel } from '../../components/ValueDisplay'
import { IBelimoEnergyValve } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { Input } from "baseui/input";
import { StatefulOperationModeSelect } from '../Aggregate'
import { OperationState } from "../OperationState";
import { GiValve } from "react-icons/gi";
import { useIntl } from 'react-intl';
import { Block } from 'baseui/block';
import { AggregateOpenCloseText } from '../Aggregate';


export function OverviewPanel(props: IBelimoEnergyValve) {
    const [css, theme] = themedUseStyletron();
    const intl = useIntl();
    const [setPosition, setSetPosition, setSetPositionResult] = useSetObjectValue(props.id, props.resourceGroupId, "setPosition", props.setPosition);
    const onSetPositionChanged = (e: any) => setSetPosition(parseFloat(e.target.value));

    return (
        <OverviewPanelWrapper {...props} icon={<GiValve color={theme.colors.backgroundPrimary} size='100%' />}>

            <GiValve color={props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off} size='40px' />
            <AggregateOpenCloseText {...props}></AggregateOpenCloseText>
            <Block alignItems={'baseline'} display={'flex'} flexDirection='row' gridGap={theme.sizing.scale500}>
                <ValueDisplayWithLabel label={intl.formatMessage({ id: "Devices.Setpoint", defaultMessage: "Setpoint" })} value={props.setPosition} dimension='%'></ValueDisplayWithLabel>
                <ValueDisplayWithLabel label={intl.formatMessage({ id: "Devices.ActualPosition", defaultMessage: "Actual Position" })} small value={props.actPosition} dimension='%' color={theme.appColors.aggregate.actualValue}></ValueDisplayWithLabel>
            </Block>
            <Block marginTop={theme.sizing.scale400} gridGap={theme.sizing.scale400} alignItems={'center'} width={'auto'} display={'flex'} flexDirection={'column'}>
                <StatefulOperationModeSelect {...props}  onSwitchManOff={() => setPosition(0)} onSwitchManOn={() => setPosition(100)}></StatefulOperationModeSelect>
                {props.isWriteable && <Input
                    value={setPosition?.toFixed(0)}
                    onChange={onSetPositionChanged}
                    type='number'
                    endEnhancer={'%'}
                    disabled={setSetPositionResult.isLoading || props.state === OperationState.Auto}
                    overrides={{ Root: { style: { width: '60%' } } }}
                />}
            </Block>

        </OverviewPanelWrapper>
    );
}